import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {config} from '../../common/config/config';
import Typography from '@mui/material/Typography';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import {PostInterface} from "../../interface/post.interface";
import {isMobile} from "react-device-detect";
import {styles} from "../../common/style";
import {useSelector} from "react-redux";
import {RootState} from "../../reducer";
import {common} from "../../common/common";
import {constance} from "../../common/constance/constance";


interface State {
    noticeList: PostInterface[],
}
export default function NoticeBox() {
    console.log(`[NoticeBox]`);

    const [state, setState] = useState<State>({
        noticeList: []
    });

    const navigate = useNavigate();
    const commonData = useSelector((state: RootState) => state.commonData);

    let userEmpty = common.isEmpty(commonData.user._id);
    useEffect(() => {
        if (!userEmpty) {
            axios.get(constance.api.getNoticeList).then(value => {
                console.log(value);
                setState({
                    noticeList: value.data.result
                })
            })
        }
    }, [commonData.user]);

    function moveNoticeView(notice: PostInterface) {
        navigate(`${config.url.postView}?id=notice&no=${notice.no}&workplace=${notice.workplace}`);
    }
    return (
        <>
            {/* 공지사항 */}
            <Box sx={{
                display: userEmpty || state.noticeList.length == 0 ? 'none' : 'flex',
                justifyContent: 'center',
                width: 1,
                mt: {xs: '75px', md: '110px'},
                pl: 1, pr: 1,
            }}>
                <Box sx={{
                    display: state.noticeList.length == 0 ? 'none' : 'flex',
                    flexDirection: {xs: 'column', sm: 'column', md: 'row'},
                    width: 1,
                    maxWidth: config.maxWidth,
                    border: styles.border,
                    borderColor: 'var(--scc-notice-border)',
                    borderRadius: 2,
                    p: 0.5,
                    background: 'var(--scc-notice-bg)',
                    alignItems: 'center',
                }}>
                    {
                        state.noticeList.map((notice, index) => {
                            console.log('notice');
                            if (isMobile && index > state.noticeList.length - 3) return;
                            return (
                                <Box key={index}
                                     onClick={() => moveNoticeView(notice)}
                                     sx={{
                                         display: 'flex',
                                         width: isMobile ? 1 : 1 / state.noticeList.length,
                                         justifyContent: 'flex-start',
                                         alignItems: 'center',
                                         p: 0.5,
                                         cursor: 'pointer',
                                         // borderRight: styles.border
                                     }}>
                                    <Typography variant={"subtitle2"}
                                                sx={{
                                                    background: '#ff0000',
                                                    color: 'white',
                                                    p: 0.3,
                                                    pr: 1,
                                                    pl: 1,
                                                    borderRadius: 1,
                                                    mr: 1
                                                }}>
                                        {'공지'}
                                    </Typography>
                                    <Typography variant={"subtitle2"} sx={{fontWeight: 400}}>
                                        {notice.title}
                                    </Typography>
                                </Box>
                            )
                        })
                    }
                </Box>
            </Box>
        </>
    );
}

